module.exports = __webpack_public_path__ + "static/media/search-meal-icon.67488c0d.png";